// import { useState } from "react";
// import {
//   ChevronUpDownIcon,
//   MagnifyingGlassIcon,
//   ChevronLeftIcon,
//   ChevronRightIcon,
//   PlusIcon,
// } from "@heroicons/react/24/outline";
// import Select from "../../Select";
// import DatePicker from "../../Calendar";
// import Checkbox from "../form/Checkbox";

// export const DataTable = ({
//   data,
//   columns,
//   searchable = false,
//   filterOptions,
//   actionButtons,
//   dateFilter,
//   pagination = true,
//   selectable = false,
//   bulkActions,
//   addButton,
// }) => {
//   // State management
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedFilters, setSelectedFilters] = useState({});
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [appliedDateRange, setAppliedDateRange] = useState({
//     start: "",
//     end: "",
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [selectedRows, setSelectedRows] = useState(new Set());
//   const [selectAll, setSelectAll] = useState(false);

//   // Filter and sort data
//   const filteredData = data
//     .filter((item) => {
//       const matchesSearch = columns.some((column) => {
//         const value = String(item[column.accessor]).toLowerCase();
//         return value.includes(searchTerm.toLowerCase());
//       });

//       const matchesFilters = Object.entries(selectedFilters).every(
//         ([key, value]) => value === "" || item[key] === value
//       );

//       const matchesDate = !dateFilter
//         ? true
//         : (!appliedDateRange.start ||
//             item[dateFilter.accessor] >= appliedDateRange.start) &&
//           (!appliedDateRange.end ||
//             item[dateFilter.accessor] <= appliedDateRange.end);

//       return matchesSearch && matchesFilters && matchesDate;
//     })
//     .sort((a, b) => {
//       if (!sortConfig.key) return 0;
//       if (a[sortConfig.key] < b[sortConfig.key])
//         return sortConfig.direction === "asc" ? -1 : 1;
//       if (a[sortConfig.key] > b[sortConfig.key])
//         return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });

//   // Pagination
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = pagination
//     ? filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       )
//     : filteredData;

//   // Selection logic
//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedRows(new Set());
//     } else {
//       const newSelection = new Set(paginatedData.map((item) => item.id));
//       setSelectedRows(newSelection);
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleSelectRow = (id) => {
//     const newSelection = new Set(selectedRows);
//     newSelection.has(id) ? newSelection.delete(id) : newSelection.add(id);
//     setSelectedRows(newSelection);
//     setSelectAll(newSelection.size === paginatedData.length);
//   };

//   // Date filter handler
//   const applyDateFilter = () => {
//     setAppliedDateRange({
//       start: startDate?.toISOString().split("T")[0] || "",
//       end: endDate?.toISOString().split("T")[0] || "",
//     });
//     setCurrentPage(1);
//   };

//   // Sorting handler
//   const handleSort = (key) => {
//     let direction = "asc";
//     if (sortConfig.key === key && sortConfig.direction === "asc")
//       direction = "desc";
//     setSortConfig({ key, direction });
//     setCurrentPage(1);
//   };

//   return (
//     <div className="rounded-xl border border-zinc-200 bg-white shadow-sm">
//       {/* Top Controls */}
//       <div className="flex flex-col gap-3 p-4 sm:p-5 border-b border-zinc-200">
//         {/* Selection Bar */}
//         {selectable && selectedRows.size > 0 && (
//           <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-zinc-50 p-3 rounded-lg">
//             <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
//               <span className="text-sm font-medium text-zinc-700">
//                 {selectedRows.size} selected
//               </span>
//               {bulkActions && (
//                 <div className="flex flex-wrap gap-2 border-t sm:border-t-0 sm:border-l border-zinc-200 pt-2 sm:pt-0 sm:pl-3">
//                   {bulkActions.map((action, index) => (
//                     <button
//                       key={index}
//                       className="px-3 py-1.5 text-sm font-medium text-zinc-700 hover:bg-zinc-100 rounded-md transition-all duration-200"
//                       onClick={() => action.onAction(Array.from(selectedRows))}
//                     >
//                       {action.label}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <button
//               onClick={() => {
//                 setSelectedRows(new Set());
//                 setSelectAll(false);
//               }}
//               className="mt-2 sm:mt-0 text-sm font-medium text-zinc-500 hover:text-zinc-700 transition-colors duration-200"
//             >
//               Clear selection
//             </button>
//           </div>
//         )}

//         {/* Search, Filters, and Add Button */}
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
//           <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-1">
//             {/* Add Button */}
//             {addButton && (
//               <button
//                 onClick={addButton.onClick}
//                 className="flex items-center gap-2 px-4 py-2 bg-zinc-900 text-white rounded-lg hover:bg-zinc-800 text-sm font-medium transition-all duration-200 whitespace-nowrap"
//               >
//                 <PlusIcon className="h-4 w-4" />
//                 {addButton.label}
//               </button>
//             )}
//             {searchable && (
//               <div className="relative w-full sm:max-w-md">
//                 <MagnifyingGlassIcon className="h-4 w-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2" />
//                 <input
//                   type="text"
//                   placeholder="Search..."
//                   className="w-full pl-9 pr-3 py-2 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 text-sm text-zinc-900 placeholder-zinc-400 transition-all duration-200"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             )}

//             {filterOptions && (
//               <div className="flex flex-wrap gap-2">
//                 {filterOptions.map((filter) => (
//                   <Select
//                     key={filter.id}
//                     options={filter.options.map((option) => ({
//                       value: option,
//                       label: option,
//                     }))}
//                     value={selectedFilters[filter.id] || ""}
//                     onChange={(value) =>
//                       setSelectedFilters((prev) => ({
//                         ...prev,
//                         [filter.id]: value,
//                       }))
//                     }
//                     placeholder={`All ${filter.label}`}
//                     containerClassName="w-full sm:w-36"
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Date Filter */}
//         {dateFilter && (
//           <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 bg-zinc-50 p-3 rounded-lg">
//             <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
//               <DatePicker
//                 selectedDate={startDate}
//                 onChange={setStartDate}
//                 placeholder="Start date"
//                 containerClassName="w-full sm:w-44"
//               />
//               <span className="text-zinc-400 text-sm hidden sm:inline">to</span>
//               <DatePicker
//                 selectedDate={endDate}
//                 onChange={setEndDate}
//                 placeholder="End date"
//                 containerClassName="w-full sm:w-44"
//               />
//             </div>
//             <div className="flex gap-2 w-full sm:w-auto">
//               <button
//                 onClick={applyDateFilter}
//                 className="px-3 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-800 text-sm font-medium transition-all duration-200 w-full sm:w-auto"
//               >
//                 Apply
//               </button>
//               <button
//                 onClick={() => {
//                   setStartDate(null);
//                   setEndDate(null);
//                   setAppliedDateRange({ start: "", end: "" });
//                 }}
//                 className="px-3 py-2 text-zinc-700 hover:bg-zinc-100 rounded-md text-sm font-medium transition-all duration-200 w-full sm:w-auto"
//               >
//                 Clear
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full min-w-[640px]">
//           <thead className="bg-zinc-50">
//             <tr>
//               {selectable && (
//                 <th className="px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 w-10">
//                   <Checkbox
//                     checked={selectAll}
//                     onChange={handleSelectAll}
//                     containerClassName="justify-center"
//                   />
//                 </th>
//               )}
//               {columns.map((column) => (
//                 <th
//                   key={column.header}
//                   className={`px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 ${
//                     column.sortable ? "cursor-pointer select-none" : ""
//                   }`}
//                   onClick={() => column.sortable && handleSort(column.accessor)}
//                 >
//                   <div className="flex items-center gap-1.5">
//                     {column.header}
//                     {column.sortable && (
//                       <ChevronUpDownIcon
//                         className={`h-4 w-4 ${
//                           sortConfig.key === column.accessor
//                             ? "text-zinc-900"
//                             : "text-zinc-400"
//                         } transition-colors duration-200`}
//                       />
//                     )}
//                   </div>
//                 </th>
//               ))}
//               {actionButtons && (
//                 <th className="px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 text-right">
//                   Actions
//                 </th>
//               )}
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-zinc-200">
//             {paginatedData.map((item) => (
//               <tr
//                 key={item.id}
//                 className="hover:bg-zinc-50 transition-colors duration-200"
//               >
//                 {selectable && (
//                   <td className="px-3 sm:px-4 py-3">
//                     <Checkbox
//                       checked={selectedRows.has(item.id)}
//                       onChange={() => handleSelectRow(item.id)}
//                       containerClassName="justify-center"
//                     />
//                   </td>
//                 )}
//                 {columns.map((column) => (
//                   <td
//                     key={column.header}
//                     className="px-3 sm:px-4 py-3 text-sm text-zinc-700 whitespace-nowrap"
//                   >
//                     {column.cell
//                       ? column.cell(item[column.accessor])
//                       : item[column.accessor]}
//                   </td>
//                 ))}
//                 {actionButtons && (
//                   <td className="px-3 sm:px-4 py-3 text-sm text-zinc-900">
//                     <div className="flex gap-2 justify-end">
//                       {actionButtons(item)}
//                     </div>
//                   </td>
//                 )}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Footer */}
//       <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border-t border-zinc-200">
//         {pagination && (
//           <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
//             <div className="flex items-center gap-2 text-sm text-zinc-700">
//               <span className="font-medium">Rows per page:</span>
//               <Select
//                 options={[10, 20, 50, 100].map((size) => ({
//                   value: size,
//                   label: size.toString(),
//                 }))}
//                 value={itemsPerPage}
//                 onChange={(value) => {
//                   setItemsPerPage(Number(value));
//                   setCurrentPage(1);
//                 }}
//                 containerClassName="w-20"
//               />
//             </div>

//             <div className="flex items-center gap-2">
//               <button
//                 className="p-1.5 rounded-md hover:bg-zinc-100 disabled:opacity-50 transition-all duration-200"
//                 onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                 disabled={currentPage === 1}
//               >
//                 <ChevronLeftIcon className="h-5 w-5 text-zinc-700" />
//               </button>
//               <span className="text-sm font-medium text-zinc-700">
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 className="p-1.5 rounded-md hover:bg-zinc-100 disabled:opacity-50 transition-all duration-200"
//                 onClick={() =>
//                   setCurrentPage((p) => Math.min(totalPages, p + 1))
//                 }
//                 disabled={currentPage === totalPages}
//               >
//                 <ChevronRightIcon className="h-5 w-5 text-zinc-700" />
//               </button>
//             </div>
//           </div>
//         )}

//         <div className="mt-3 sm:mt-0 text-sm text-zinc-500 font-medium">
//           Showing {paginatedData.length} of {filteredData.length} results
//         </div>
//       </div>

//       {/* Empty State */}
//       {filteredData.length === 0 && (
//         <div className="p-8 text-center">
//           <div className="mx-auto h-16 w-16 text-zinc-200 mb-3">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={1.5}
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.25 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
//               />
//             </svg>
//           </div>
//           <p className="text-sm text-zinc-500 font-medium">No records found</p>
//         </div>
//       )}
//     </div>
//   );
// };

import { useEffect, useState } from "react";
import {
  ChevronUpDownIcon,
  MagnifyingGlassIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import Select from "./Select";
import DatePicker from "./Calendar";
import Checkbox from "./Checkbox";
import { useStateContext } from "../contexts/ContextProvider";

export const DataTable = ({
  data,
  columns,
  searchable = false,
  filterOptions,
  actionButtons,
  dateFilter,
  pagination = true,
  selectable = false,
  bulkActions,
  addButton,
  dateSearch,
  itemsPerPageOptions = [10, 20, 50, 100],
}) => {
  // State management
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
   const { setToken, user,ajouterCheque,supprimerCheque,chequesList,setChequesList } = useStateContext();
  const [appliedDateRange, setAppliedDateRange] = useState({
    start: "",
    end: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);

  // Filter and sort data
  const filteredData = data
    .filter((item) => {
      const matchesSearch = columns.some((column) => {
        const value = String(item[column.accessor]).toLowerCase();
        return value.includes(searchTerm.toLowerCase());
      });

      const matchesFilters = Object.entries(selectedFilters).every(
        ([key, value]) => value === "" || item[key] === value
      );

      const matchesDate = !dateFilter
        ? true
        : (!appliedDateRange.start ||
            item[dateFilter.accessor] >= appliedDateRange.start) &&
          (!appliedDateRange.end ||
            item[dateFilter.accessor] <= appliedDateRange.end);

      return matchesSearch && matchesFilters && matchesDate;
    })
    .sort((a, b) => {
      if (!sortConfig.key) return 0;
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  // Pagination
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = pagination
    ? filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : filteredData;

  // Selection logic
  // const handleSelectAll = () => {
  //   if (selectAll) {
  //     setSelectedRows(new Set());
  //     // setChequesList(selectedRows);
      
  //   } else {
  //     const newSelection = new Set(paginatedData.map((item) => item.id));
      
  //     setSelectedRows(newSelection);
  //   }
  //   console.log(selectedRows);
  //   setSelectAll(!selectAll);
  // };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows(new Set());
      setChequesList([]);
    } else {
      const newSelection = new Set(paginatedData.map((item) => item.id));
      setSelectedRows(newSelection);
      // solution
      const selectedData = data.filter((d) => newSelection.has(d.id));
      setChequesList(selectedData);
    }
    setSelectAll(!selectAll);
  };
  

  const handleSelectRow = (id) => {
    const newSelection = new Set(selectedRows);
    newSelection.has(id) ? newSelection.delete(id) : newSelection.add(id);
      setSelectedRows(newSelection);
    setSelectAll(newSelection.size === paginatedData.length);
    // solution 
    const selectedData = data.filter((d) => newSelection.has(d.id));
  setChequesList(selectedData);
  };

  useEffect(() => {
    console.log("Cheques sélectionnés:", chequesList);
  }, [chequesList]);

  // Date filter handler
  // const applyDateFilter = () => {
  //   setAppliedDateRange({
  //     start: startDate?.toISOString().split("T")[0] || "",
  //     end: endDate?.toISOString().split("T")[0] || "",
  //   });
  //   setCurrentPage(1);
  // };

  // Sorting handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc")
      direction = "desc";
    setSortConfig({ key, direction });
    setCurrentPage(1);
  };

  return (
    <div className="rounded-xl border border-zinc-200 bg-white shadow-sm">
      {/* Top Controls */}
      <div className="flex flex-col gap-3 p-4 sm:p-5 border-b border-zinc-200">
        {/* Selection Bar */}
        {selectable && selectedRows.size > 0 && (
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-zinc-50 p-3 rounded-lg">
            {/* <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <span className="text-sm font-medium text-zinc-700">
                {selectedRows.size} selected
              </span>
              {bulkActions && (
                <div className="flex flex-wrap gap-2 border-t sm:border-t-0 sm:border-l border-zinc-200 pt-2 sm:pt-0 sm:pl-3">
                  {bulkActions.map((action, index) => (
                    <button
                      key={index}
                      className="px-3 py-1.5 text-sm font-medium text-zinc-700 hover:bg-zinc-100 rounded-md transition-all duration-200"
                      onClick={() => action.onAction(Array.from(selectedRows))}
                    >
                      {action.label}
                    </button>
                  ))}
                </div>
              )}
            </div> */}
            <button
              onClick={() => {
                setSelectedRows(new Set());
                setSelectAll(false);
              }}
              className="mt-2 sm:mt-0 text-sm font-medium text-zinc-500 hover:text-zinc-700 transition-colors duration-200"
            >
              Clear selection
            </button>
          </div>
        )}

        {/* Search, Filters, and Add Button */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between flex-1  gap-3">
            {/* Add Button */}
            {addButton && (
              <button
                onClick={addButton.onClick}
                className="flex items-center gap-2 px-4 py-2 bg-zinc-900 text-white rounded-lg hover:bg-zinc-800 text-sm font-medium transition-all duration-200 whitespace-nowrap"
              >
                <PlusIcon className="h-4 w-4" />
                {addButton.label}
              </button>
            )}
            {searchable && (
              <div className="relative w-full sm:max-w-md">
                <MagnifyingGlassIcon className="h-4 w-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="w-full pl-9 pr-3 py-2 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 text-sm text-zinc-900 placeholder-zinc-400 transition-all duration-200"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            )}

            {/* {filterOptions && (
              <div className="flex flex-wrap gap-2">
                {filterOptions.map((filter) => (
                  <Select
                    key={filter.id}
                    options={filter.options.map((option) => ({
                      value: option,
                      label: option,
                    }))}
                    value={selectedFilters[filter.id] || ""}
                    onChange={(value) =>
                      setSelectedFilters((prev) => ({
                        ...prev,
                        [filter.id]: value,
                      }))
                    }
                    placeholder={`All ${filter.label}`}
                    containerClassName="w-full sm:w-36"
                  />
                ))}
              </div>
            )} */}
          </div>
        </div>

        {/* Date Filter */}
        
          {dateSearch}
       
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-zinc-50">
            <tr>
              {selectable && (
                <th className="px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 w-10">
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    containerClassName="justify-center"
                  />
                </th>
              )}
              {columns.map((column) => (
                <th
                  key={column.header}
                  className={`px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 ${
                    column.sortable ? "cursor-pointer select-none" : ""
                  }`}
                  onClick={() => column.sortable && handleSort(column.accessor)}
                >
                  <div className="flex items-center gap-1.5">
                    {column.header}
                    {column.sortable && (
                      <ChevronUpDownIcon
                        className={`h-4 w-4 ${
                          sortConfig.key === column.accessor
                            ? "text-zinc-900"
                            : "text-zinc-400"
                        } transition-colors duration-200`}
                      />
                    )}
                  </div>
                </th>
              ))}
              {actionButtons && (
                <th className="px-3 sm:px-4 py-3 text-sm font-semibold text-zinc-900 text-right">
                  Actions
                </th>
              )}
            </tr>
          </thead>

          <tbody className="divide-y divide-zinc-200">
            {paginatedData.map((item) => (
              <tr
                key={item.id}
                className="hover:bg-zinc-50 transition-colors duration-200"
              >
                {selectable && (
                  <td className="px-3 sm:px-4 py-3">
                    <Checkbox
                      checked={selectedRows.has(item.id)}
                      onChange={() => handleSelectRow(item.id)}
                      containerClassName="justify-center"
                    />
                  </td>
                )}
                {columns.map((column) => (
                  <td
                    key={column.header}
                    className="px-3 sm:px-4 py-3 text-sm text-zinc-700 whitespace-nowrap"
                  >
                    {column.cell
                      ? column.cell(item[column.accessor])
                      : item[column.accessor]}
                  </td>
                ))}
                {actionButtons && (
                  <td className="px-3 sm:px-4 py-3 text-sm text-zinc-900">
                    <div className="flex gap-2 justify-end">
                      {actionButtons(item)}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border-t border-zinc-200">
        {pagination && (
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
            {itemsPerPageOptions.length > 0 && (
              <div className="flex items-center gap-2 text-sm text-zinc-700">
                <span className="font-medium">Rows per page:</span>
                <Select
                  options={itemsPerPageOptions.map((size) => ({
                    value: size,
                    label: size.toString(),
                  }))}
                  value={itemsPerPage}
                  onChange={(value) => {
                    setItemsPerPage(Number(value));
                    setCurrentPage(1);
                  }}
                  containerClassName="w-20"
                />
              </div>
            )}

            <div className="flex items-center gap-2">
              <button
                className="p-1.5 rounded-md hover:bg-zinc-100 disabled:opacity-50 transition-all duration-200"
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
              >
                <ChevronLeftIcon className="h-5 w-5 text-zinc-700" />
              </button>
              <span className="text-sm font-medium text-zinc-700">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="p-1.5 rounded-md hover:bg-zinc-100 disabled:opacity-50 transition-all duration-200"
                onClick={() =>
                  setCurrentPage((p) => Math.min(totalPages, p + 1))
                }
                disabled={currentPage === totalPages}
              >
                <ChevronRightIcon className="h-5 w-5 text-zinc-700" />
              </button>
            </div>
          </div>
        )}

        <div className="mt-3 sm:mt-0 text-sm text-zinc-500 font-medium">
          Showing {paginatedData.length} of {filteredData.length} results
        </div>
      </div>

      {/* Empty State */}
      {filteredData.length === 0 && (
        <div className="p-8 text-center">
          <div className="mx-auto h-16 w-16 text-zinc-200 mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.25 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
              />
            </svg>
          </div>
          <p className="text-sm text-zinc-500 font-medium">No records found</p>
        </div>
      )}
    </div>
  );
};
